import { render, staticRenderFns } from "./ToVerify.vue?vue&type=template&id=c6853afe&"
import script from "./ToVerify.vue?vue&type=script&lang=js&"
export * from "./ToVerify.vue?vue&type=script&lang=js&"
import style0 from "./ToVerify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports